import { IPromise } from 'angular';
import * as _ from 'underscore';
import { getViewInfos } from '../../app/sagas/spaces/SpacesSagaHelpers';
import { Formatters, Messages } from '../../codegen/Localize';
import { IActionContext } from '../helpers/ActionContext';
import { ResultHelper } from '../helpers/ResultHelper';
import { L10n } from '../L10n/L10n';
import { ExplorableItemType } from '../models/ContentType';
import { FlowListItemInfo } from '../models/FlowInfo';
import { IContentInfo } from '../models/IContentInfo';
import { IDataAlertBase } from '../models/IDataAlertInfo';
import { IDataRoleInfo } from '../models/IDataRoleInfo';
import { IDataSourceInfo } from '../models/IDataSourceInfo';
import { IMetricInfo } from '../../metrics/models/IMetricInfo';
import { IProjectInfo } from '../models/IProjectInfo';
import { IPublishedConnectionInfo } from '../models/IPublishedConnectionInfo';
import { IScheduleInfo } from '../models/IScheduleInfo';
import { IViewInfo } from '../models/IViewInfo';
import { IWorkbookInfo, IWorkbookParentInfo } from '../models/IWorkbookInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DataAlerts } from '../resources/DataAlerts';
import { DataRoles } from '../resources/Dataroles';
import { DataSources } from '../resources/Datasources';
import { Flows } from '../resources/Flows';
import { Metrics } from '../../metrics/resources/Metrics';
import { Projects } from '../resources/Projects';
import { PublishedConnections } from '../resources/PublishedConnections';
import { RunFlowTasks } from '../resources/RunFlowTasks';
import { Schedules } from '../resources/Schedules';
import { Views } from '../resources/Views';
import { Workbooks } from '../resources/Workbooks';
import { IError } from '../ServerApi/types/IError';
import { IResult } from '../ServerApi/types/IResponse';
import { ActionHelpers } from './ActionHelpers';
import { IErrorDetail } from './ContentActionNotification';
import { DataRoleErrors } from './DataRoleErrors';
import { DataSourceErrors } from './DataSourceErrors';
import { DeleteRunFlowTasksAction } from './DeleteRunFlowTasksAction';
import { FlowErrors } from './FlowErrors';
import { HideViewsAction } from './HideViewsAction';
import { MetricErrors } from '../../metrics/services/MetricErrors';
import { ProjectErrors } from './ProjectErrors';
import { PublishedConnectionErrors } from './PublishedConnectionErrors';
import { ScheduleErrors } from './ScheduleErrors';
import { ViewErrors } from './ViewErrors';
import { WorkbookErrors } from './WorkbookErrors';
import { openConfirmActionDialog } from './ReactConfirmActionDialog';
import { ReactConfirmActionStringBodyProps, ReactConfirmActionStringBody, ReactAreYouSureConfirmActionStringBody } from './ReactConfirmActionStringBody';
import { CollectionsResourceQuery } from '../../app/spaces/Collections/Collections';
import { DeleteCollectionData } from '../../app/spaces/Collections/CollectionModels';
import { CollectionMapper } from '../mappers/CollectionMapper';
import { CollectionErrors } from './CollectionErrors';
import { DeleteSchedulesAction } from './DeleteSchedulesAction';
import { DataAlertErrors } from './DataAlertErrors';

export interface ContentTypeAndID {
  contentType: ExplorableItemType;
  id: string;
}
export interface IDeleteContentsResult extends IResult {
  deletedItems: ContentTypeAndID[];
}

export class DeleteContentsAction {

  public static $inject = ['WorkbookErrors', 'ProjectErrors', 'DataRoleErrors', 'DataSourceErrors', 'ViewErrors', 'FlowErrors',  'ActionHelpers',
    '$translate', 'Workbooks', 'DataSources', 'Projects', 'Views', 'Metrics', 'Flows', 'PublishedConnections', 'DataRoles', '$q', 'DataAlertErrors', 'DataAlerts',
    'ScheduleErrors', 'Schedules', 'DeleteSchedulesAction', 'DeleteRunFlowTasksAction', 'RunFlowTasks'
  ];

  constructor(
    private WorkbookErrors: WorkbookErrors,
    private ProjectErrors: ProjectErrors,
    private DataRoleErrors: DataRoleErrors,
    private DataSourceErrors: DataSourceErrors,
    private ViewErrors: ViewErrors,
    private FlowErrors: FlowErrors,
    private ActionHelpers: ActionHelpers,
    private $translate: ng.translate.ITranslateService,
    private Workbooks: Workbooks,
    private DataSources: DataSources,
    private Projects: Projects,
    private Views: Views,
    private Metrics: Metrics,
    private Flows: Flows,
    private PublishedConnections: PublishedConnections,
    private DataRoles: DataRoles,
    private $q: ng.IQService,
    private DataAlertErrors: DataAlertErrors,
    private DataAlerts: DataAlerts,
    private ScheduleErrors: ScheduleErrors,
    private Schedules: Schedules,
    private DeleteSchedulesActions: DeleteSchedulesAction,
    private DeleteRunFlowTasksAction: DeleteRunFlowTasksAction,
    private RunFlowTasks: RunFlowTasks) {
    }

  public confirmDeleteContents(contents: IContentInfo[], context: IActionContext): ng.IPromise<IDeleteContentsResult>{
    let projects: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let workbooks: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let dataRoles: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let datasources: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let views: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let flows: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let publishedConnections: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let collections: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let metrics: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let alerts: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let schedules: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    let runFlowTasks: Set<IContentInfo> = new Set<IContentInfo>((contentInfo: IContentInfo) => contentInfo.id);
    contents.forEach((contentItem) => {
      switch (contentItem.contentType) {
        case 'project':
          projects.add(contentItem);
          break;
        case 'workbook':
          workbooks.add(contentItem);
          break;
        case 'dataRole':
          dataRoles.add(contentItem);
          break;
        case 'datasource':
          datasources.add(contentItem);
          break;
        case 'view':
          views.add(contentItem);
          break;
        case 'flow':
          flows.add(contentItem);
          break;
        case 'publishedConnection':
          publishedConnections.add(contentItem);
          break;
        case 'collection':
          collections.add(contentItem);
          break;
        case 'metric':
          metrics.add(contentItem);
          break;
        case 'dataalert':
          alerts.add(contentItem);
          break;
        case 'schedule':
          schedules.add(contentItem);
        case 'runFlowTask':
          runFlowTasks.add(contentItem);
        default:
          break;
      }
    });

    let workbooksToBeDeleted: IWorkbookParentInfo[] = [];
    let dialogBody: string = '';
    let determineWorkbooksToBeDeletedPromise: IPromise<IViewInfo[]>;
    if(views.size() > 0) {
      determineWorkbooksToBeDeletedPromise = getViewInfos(views.toArray());
    } else {
      determineWorkbooksToBeDeletedPromise = Q.when([]) as ng.IPromise<IViewInfo[]>;
    }

    return determineWorkbooksToBeDeletedPromise.then((viewDetailArray: IViewInfo[]) => {
      if(views.size() > 0) {
        workbooksToBeDeleted = HideViewsAction
          .determineWorkbooksToBeDeleted(Set.fromIdItemArray(viewDetailArray));
      }
      dialogBody = this.buildConfirmationDialog(contents, workbooksToBeDeleted);
      return this.buildDialogBox(
        context,
        dialogBody,
        contents,
        projects,
        workbooks,
        dataRoles,
        datasources,
        views,
        flows,
        publishedConnections,
        collections,
        metrics,
        alerts,
        schedules,
        runFlowTasks);
    });
  }

  private buildDialogBox(
    context: IActionContext,
    dialogBody: string,
    contents: IContentInfo[],
    projects: Set<IContentInfo>,
    workbooks: Set<IContentInfo>,
    dataRoles: Set<IContentInfo>,
    datasources: Set<IContentInfo>,
    views: Set<IContentInfo>,
    flows: Set<IContentInfo>,
    publishedConnections: Set<IContentInfo>,
    collections: Set<IContentInfo>,
    metrics: Set<IContentInfo>,
    alerts: Set<IContentInfo>,
    schedules: Set<IContentInfo>,
    runFlowTasks: Set<IContentInfo>
): IPromise<IDeleteContentsResult> {

    const initialModalInstance = openConfirmActionDialog<ReactConfirmActionStringBodyProps, any, IResult>({
      title:  Messages.deleteMessage(),
      bodyComponent: ReactConfirmActionStringBody,
      initialBodyProps: {message: dialogBody},
      initialDialogState: {},
      actionName: Messages.confirmDeleteButton({ITEM_COUNT: contents.length, ITEM_COUNT_LOC: Formatters.formatCount(contents.length)}),
      //If the set of content items included any projects, we defer deletion until a second 'Are you sure' confirmation is given. If no projects are being deleted, proceed after the user clicks 'Delete'
      action: () => {
        return projects.size() > 0 ? null : this.deleteContent(projects, workbooks, dataRoles, datasources, views, flows, publishedConnections, collections, metrics, alerts, schedules, runFlowTasks);
      },
      isActionDelete: true
    });

    return initialModalInstance.result.then((result) => {
      initialModalInstance.dismiss();

      if (projects.size() === 0) {
        //Content is deleted, no second confirmation is needed
        return result;
      }

      const modalInstance = openConfirmActionDialog<ReactConfirmActionStringBodyProps, any, IResult>({
        title: '',
        bodyComponent: ReactAreYouSureConfirmActionStringBody,
        initialBodyProps: {message: Messages.actionNotUndoable()},
        initialDialogState: {},
        actionName: Messages.confirmDeleteProjectsDefinitely({ PROJECT_COUNT: projects.size() }),
        action: () => {
          return this.deleteContent(projects, workbooks, dataRoles, datasources, views, flows, publishedConnections, collections, metrics, alerts, schedules, runFlowTasks);
        },
        isActionDelete: true,
        centerActionButtons: true
      });
      return modalInstance.result;
    });
  }

  private deleteContent(
    projects: Set<IContentInfo>,
    workbooks: Set<IContentInfo>,
    dataRoles: Set<IContentInfo>,
    datasources: Set<IContentInfo>,
    views: Set<IContentInfo>,
    flows: Set<IContentInfo>,
    publishedConnections: Set<IContentInfo>,
    collections: Set<IContentInfo>,
    metrics: Set<IContentInfo>,
    alerts: Set<IContentInfo>,
    schedules: Set<IContentInfo>,
    runFlowTasks: Set<IContentInfo>
  ): IPromise<IDeleteContentsResult> {
    let aggregateResult: IDeleteContentsResult[] = [];
    let outstandingPromises: IPromise<IResult>[] = [];

    if (projects.size() > 0) {
      const deleteProjects = this.Projects.del(projects.map(item => item.id));
      outstandingPromises.push(deleteProjects);
      deleteProjects.then(
        (result: IResult) => {
          const deletedProjects: ContentTypeAndID[] = getActuallyDeletedItems(projects, result);
          aggregateResult.push({ deletedItems: deletedProjects, errors: result.errors });
          this.notifyResult(projects, result,
            'deleteProjectsSuccess', 'deleteProjectsError',
            (errorItem: IErrorItem<IProjectInfo>) => this.ProjectErrors.errorDetailsFor(errorItem));
        });
    }
    if (workbooks.size() > 0) {
      const deleteWorkbooks = this.Workbooks.del(workbooks.map(item => item.id));
      outstandingPromises.push(deleteWorkbooks);
      deleteWorkbooks.then(
        (result: IResult) => {
          const deletedWorkbooks: ContentTypeAndID[] = getActuallyDeletedItems(workbooks, result);
          aggregateResult.push({ deletedItems: deletedWorkbooks, errors: result.errors });
          this.notifyResult(workbooks, result,
            'deleteWorkbooksSuccess', 'deleteWorkbooksError',
            (errorItem: IErrorItem<IWorkbookInfo>) => this.WorkbookErrors.errorDetailsFor(errorItem));
        });
    }
    if (dataRoles.size() > 0) {
      const deleteDataRoles = this.DataRoles.deleteDataRoles(dataRoles.map(item => item.id));
      outstandingPromises.push(deleteDataRoles);
      deleteDataRoles.then(
        (result: IResult) => {
          const deletedDRs: ContentTypeAndID[] = getActuallyDeletedItems(dataRoles, result);
          aggregateResult.push({ deletedItems: deletedDRs, errors: result.errors });
          this.notifyResult(dataRoles, result,
            'deleteDataRolesSuccess', 'deleteDataRolesError',
            (errorItem: IErrorItem<IDataRoleInfo>) => this.DataRoleErrors.errorDetailsFor(errorItem));
        });
    }
    if (datasources.size() > 0) {
      const deleteDatasources = this.DataSources.del(datasources.map(item => item.id));
      outstandingPromises.push(deleteDatasources);
      deleteDatasources.then(
        (result: IResult) => {
          const deletedDSs: ContentTypeAndID[] = getActuallyDeletedItems(datasources, result);
          aggregateResult.push({ deletedItems: deletedDSs, errors: result.errors });
          this.notifyResult(datasources, result,
            'deleteDatasourcesSuccess', 'deleteDatasourcesError',
            (errorItem: IErrorItem<IDataSourceInfo>) => this.DataSourceErrors.errorDetailsFor(errorItem));
        });
    }
    if (views.size() > 0) {
      const deleteViews = this.Views.hide(views.map(item => item.id));
      outstandingPromises.push(deleteViews);
      deleteViews.then(
        (result: IResult) => {
          const deletedViews: ContentTypeAndID[] = getActuallyDeletedItems(views, result);
          aggregateResult.push({ deletedItems: deletedViews, errors: result.errors });
          this.notifyResult(views, result,
            'deleteViewsSuccess', 'deleteViewsError',
            (errorItem: IErrorItem<IViewInfo>) => this.ViewErrors.errorDetailsFor(errorItem));
        });
    }
    if (flows.size() > 0) {
      const deleteFlows = this.Flows.deleteFlows(flows.map(item => item.id));
      outstandingPromises.push(deleteFlows);
      deleteFlows.then(
        (result: IResult) => {
          const deletedFlows: ContentTypeAndID[] = getActuallyDeletedItems(flows, result);
          aggregateResult.push({ deletedItems: deletedFlows, errors: result.errors });
          this.notifyResult(flows, result,
            'deleteFlowsSuccess', 'deleteFlowsError',
            (errorItem: IErrorItem<FlowListItemInfo>) => this.FlowErrors.errorDetailsFor(errorItem));
        });
    }
    if (publishedConnections.size() > 0) {
      const deletePublishedConnections = this.PublishedConnections.del(publishedConnections.map(item => item.id));
      outstandingPromises.push(deletePublishedConnections);
      deletePublishedConnections.then(
        (result: IResult) => {
          const deletedPublishedConnections: ContentTypeAndID[] = getActuallyDeletedItems(publishedConnections, result);
          aggregateResult.push({ deletedItems: deletedPublishedConnections, errors: result.errors });
          this.notifyResult(publishedConnections, result,
            'deletePublishedConnectionsSuccess', 'deletePublishedConnectionsError',
            (errorItem: IErrorItem<IPublishedConnectionInfo>) => PublishedConnectionErrors.errorDetailsFor(errorItem));
        });
    }
    if (collections.size() > 0) {
      const deleteCollectionsPromise = (new CollectionsResourceQuery()).delete(collections.map(item => item.luid)).then(
        (result: DeleteCollectionData): IResult => {
          return CollectionMapper.mapDeleteCollectionsDataToIResult(result, collections);
        }
      );
      outstandingPromises.push(deleteCollectionsPromise);
      deleteCollectionsPromise.then(
        (result: IResult) => {
          const deletedCollections: ContentTypeAndID[] = getActuallyDeletedItems(collections, result);
          aggregateResult.push({ deletedItems: deletedCollections, errors: result.errors });
          this.notifyResult(collections, result,
            'deleteCollectionsSuccess', 'deleteCollectionsError',
            (errorItem: IErrorItem<IContentInfo<'collection'>>) => CollectionErrors.errorDetailsFor(errorItem));
        }).catch((error) => {
          return {errors: [{code: error.data.errorCode}]} as IResult;
        });
    }
    if (alerts.size() > 0) {
      const deleteAlerts = this.DataAlerts.del(alerts.map(item => item.id));
      outstandingPromises.push(deleteAlerts);
      deleteAlerts.then(
        (result: IResult) => {
          const deletedAlerts: ContentTypeAndID[] = getActuallyDeletedItems(alerts, result);
          aggregateResult.push({ deletedItems: deletedAlerts, errors: result.errors });
          this.notifyResult<IDataAlertBase>(
            alerts as Set<IDataAlertBase>,
            result,
            'deleteDataAlertsSuccess', 'deleteDataAlertsError',
            (errorItem: IErrorItem<IDataAlertBase>) => this.DataAlertErrors.errorDetailFor(errorItem));
        });
    }
    if (schedules.size() > 0) {
      const deleteSchedules = this.Schedules.del(schedules.map(item => item.id));
      outstandingPromises.push(deleteSchedules);
      deleteSchedules.then(
        (result: IResult) => {
          const deleteSchedules: ContentTypeAndID[] = getActuallyDeletedItems(schedules, result);
          aggregateResult.push({ deletedItems: deleteSchedules, errors: result.errors });
          this.notifyResult<IScheduleInfo>(
            schedules as unknown as Set<IScheduleInfo>,
            result,
            'deleteSchedulesSuccess', 'deleteSchedulesError',
            (errorItem: IErrorItem<IScheduleInfo>) => this.ScheduleErrors.errorDetailsFor(errorItem));
        });
    }
    if (runFlowTasks.size() > 0) {
      const deleteRunFlowTasks = this.RunFlowTasks.del(runFlowTasks.map(item => item.id));
      outstandingPromises.push(deleteRunFlowTasks);
      deleteRunFlowTasks.then(
        (result: IResult) => {
          const deletedRunFlowTasks: ContentTypeAndID[] = getActuallyDeletedItems(runFlowTasks, result);
          aggregateResult.push({ deletedItems: deletedRunFlowTasks, errors: result.errors });
          this.notifyResult<RunFlowTaskInfo>(
            runFlowTasks as unknown as Set<RunFlowTaskInfo>,
            result,
            'deleteRunFlowTasksSuccess', 'deleteRunFlowTasksError',
            (errorItem: IErrorItem<RunFlowTaskInfo>) => this.DeleteRunFlowTasksAction.errorDetailFor(errorItem));
        });
    }
    if (metrics.size() > 0) {
      const deleteMetrics = this.Metrics.del(metrics.map(item => item.id));
      outstandingPromises.push(deleteMetrics);
      deleteMetrics.then(
        (result: IResult) => {
          const deletedMetrics: ContentTypeAndID[] = getActuallyDeletedItems(metrics, result);
          aggregateResult.push({ deletedItems: deletedMetrics, errors: result.errors });
          this.notifyResult(metrics, result,
            'deleteMetricsSuccess', 'deleteMetricsError',
            (errorItem: IErrorItem<IMetricInfo>) => MetricErrors.errorDetailsFor(errorItem));
        });
    }
    return this.$q.all(outstandingPromises).then(() => {
      return combineIDeleteContentsResults(aggregateResult);
    });
  }

  private buildConfirmationDialog(contents: IContentInfo[], workbooksToBeDeleted: IWorkbookParentInfo[]): string {
    let dialogBody = '';
    if (contents.length === 1) {
      let contentName;
      if (contents[0].contentType === 'runFlowTask') {
        const runFlowTaskContent: RunFlowTaskInfo = contents[0] as unknown as RunFlowTaskInfo;
        contentName = runFlowTaskContent.flow.name;
      } else {
        contentName = contents[0].name;
      }

      if (contents[0].contentType === 'schedule') {
        return this.DeleteSchedulesActions.deleteSingleScheduleBodyText(contents[0] as unknown as IScheduleInfo);
      }

      dialogBody += Messages.confirmDeleteContent({
        CONTENT_NAME: L10n.elideIfLong(contentName),
        CONTENT_TYPE: L10n.elideIfLong(this.$translate.instant(contents[0].contentType))
      });

      if(contents[0].contentType === 'project') {
        dialogBody += Messages.deleteProjectWarning();
      }

      if(contents[0].contentType === 'collection') {
        dialogBody += Messages.deleteCollectionWarning();
      }
    } else {
      dialogBody += Messages.confirmDeleteContents({
        CONTENT_COUNT_LOC: Formatters.formatCount(contents.length)
      });
    }

    if (workbooksToBeDeleted.length > 0) {
      const workbooksWarning = Messages.confirmDeleteViewsWorkbookWarning({
        WORKBOOK_COUNT: workbooksToBeDeleted.length,
        WORKBOOK_COUNT_LOC: Formatters.formatCount(workbooksToBeDeleted.length),
        WORKBOOK_NAME: L10n.elideIfLong(workbooksToBeDeleted[0].name)
      });
      dialogBody = dialogBody + ' ' + workbooksWarning;
    }
    return dialogBody;
  }

  private notifyResult<T>(contents: Set<T>, result: IResult,
    successId: string, errorId: string,
    describeErrorDetailFunc: (errorItem: IErrorItem<T>) => IErrorDetail
  ) {
    this.ActionHelpers.notifyStandardError(
      contents,
      {
        successId: successId,
        errorId: errorId
      },
      describeErrorDetailFunc)(result);
  }
}

// exported for testing
export function getActuallyDeletedItems(items: Set<IContentInfo<ExplorableItemType>>, result: IResult): ContentTypeAndID[] {
  const deletedItems: ContentTypeAndID[] = [];
  items.each((item: IContentInfo<ExplorableItemType>) => {
    if (result.errors && !_.any(result.errors, (error: IError) => {
      return (item.contentType === 'collection') ? (error.id === item.luid) : (error.id === item.id);
    })) {
      deletedItems.push({ id: item.id, contentType: item.contentType });
    }
  });
  return deletedItems;
}

function combineIDeleteContentsResults(results: IDeleteContentsResult[]): IDeleteContentsResult {
  return {
    deletedItems: ResultHelper.combine(results, (result) => result.deletedItems),
    errors: ResultHelper.combineErrors(results)
  };
}


Module.instance().service('DeleteContentsAction', DeleteContentsAction);

